import { gql } from 'graphql-request'

export const QueryBlock3CardsWithImage = gql`
  fragment FragmentBlock3CardsWithImage on Block3CardsWithImageModelRecord {
    __typename
    id
    preface
    title
    theme
    cardsContainerTheme
    action {
      ...FragmentNavigationItem
    }
    featureCards {
      ...FragmentFeatureCardBlock
    }
    image {
      url
      responsiveImage {
        ...responsiveImageFragment
      }
      title
    }
  }
`

export const Block3CardsWithImage = {
  __typename: 'Block3CardsWithImage',
  fragmentName: 'FragmentBlock3CardsWithImage',
  fragmentQuery: QueryBlock3CardsWithImage,
  fragments: ['FragmentNavigationItem', 'FragmentFeatureCardBlock']
}
